
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/SearchResultsPage/SearchResultsPage",
      function () {
        return require("private-next-pages/search/SearchResultsPage/SearchResultsPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/SearchResultsPage/SearchResultsPage"])
      });
    }
  